<!-- @format -->

<ng-container *transloco="let t">
  <fudis-section
    [class]="'fudis-mt-md'"
    [width]="'lg'"
    [level]="2"
    [titleVariant]="'lg'"
    [title]="stepNumber + '. ' + t('GRADUATION_WIZARD.STEP_1')">
    <fudis-section-content>
      <sis-graduation-instructions [organisationId]="organisationId"></sis-graduation-instructions>
      <sis-wizard-step-buttons
        [backButtonDisplay]="false"
        [forwardButtonTitle]="t('GRADUATION_WIZARD.CONTINUE_BUTTON')"
        (forward)="forward.emit()">
      </sis-wizard-step-buttons>
    </fudis-section-content>
  </fudis-section>
</ng-container>
